import { render, staticRenderFns } from "./Bitterbal.vue?vue&type=template&id=3b77c621&"
import script from "./Bitterbal.vue?vue&type=script&lang=js&"
export * from "./Bitterbal.vue?vue&type=script&lang=js&"
import style0 from "./Bitterbal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports